import { API_BASE_URL } from '../api/axios';

/**
 * Join API base URL with a stored upload path (`/uploads/file.pdf` or `uploads/file.pdf`).
 * Avoids double slashes after the host.
 */
export function buildApiAssetUrl(storedPath) {
  if (!storedPath || typeof storedPath !== 'string') return '';

  const base = String(API_BASE_URL || '').replace(/\/+$/, '');
  const pathPart = storedPath.replace(/^\/+/, '');
  if (!pathPart) return base;
  return `${base}/${pathPart}`;
}

export const CANDIDATE_DOCUMENT_FIELDS = {
  resume: 'updatedResume',
  ornnovaProfile: 'ornnovaProfile',
};
